import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=c089e8a0&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c089e8a0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HalfNHalf: require('/home/topspuk/builds/WLymjMOvx/0/standbyteam/topspizza.co.uk/frontend/web/components/HalfNHalf.vue').default})
